import { IconDot } from '@/assets';
import HoverGridCanvas from '@/components/common/HoverGridCanvas';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionTechnologies = () => {
  const { t } = useTranslation();
  const competitiveAdvantages = [
    {
      number: '01',
      title: t('Software Development'),
      desc: [
        '#PHP',
        '#Laravel',
        '#Ruby',
        '#Java',
        '#Spring',
        '#.Net',
        '#NodeJs',
        '#React',
        '#Vue.js',
        '#AngularJS',
        '#Python',
      ],
    },
    {
      number: '02',
      title: t('Mobile Applications'),
      desc: ['#IOS', '#Swift', '#Java', '#React', '#Flutter', '#AngularJS'],
    },
    {
      number: '03',
      title: t('Data Base'),
      desc: ['#Amozon', '#MongoDB', '#MySQL'],
    },
  ];
  return (
    <section className="competitive-advantages section-technologies">
      <HoverGridCanvas />
      <div className="competitive-advantages__content">
        <p className="title">{t('Technologies')}</p>
        <div className="list-items">
          {competitiveAdvantages.map((item, index) => (
            <div className="item" key={item.number}>
              <div className="item__top">
                <span className="number">{item.number}</span>
                <span className="title-item">{item.title}</span>
              </div>
              <div className="item__bottom">
                <div className="flex">
                  <div className="icon-dot">
                    <IconDot />
                  </div>
                  <div className="tag">
                    {item.desc.map((tag) => (
                      <span key={tag} className="tag-desc">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="icon-dot">
                  <IconDot />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(SectionTechnologies);
